// components/FunktionsBanner.jsx — „Die komplette Turnierlösung“ (18.10.2026)
//
// Vorläufiger Ersatz für /platform-features-v2.webp: das KI-Bild trug
// verstümmelten Text („Enselanmeldungen“, „Feahoort“, „Daten Datan“).
// Hier als echter Text, lesbar in beiden Modi und am Handy.
// ⚠️ Später kommt ein neues Bild. Die alte Datei liegt weiter in public/,
// sie wird nur nicht mehr eingebunden.
import React from 'react';
import './FunktionsBanner.css';

const FUNKTIONEN = [
  { titel: 'Online-Anmeldung', text: 'Vereine melden ihre Starter selbst an, mit Gebühren und Bestätigung.' },
  { titel: 'Brackets und Zeitplan', text: 'Turnierbäume und Pools entstehen aus den Anmeldungen, verteilt auf die Matten.' },
  { titel: 'Kampfrichter-App', text: 'Wertung am Handy oder Tablet, direkt auf den Hallenschirm.' },
  { titel: 'Live-Ergebnisse', text: 'Zuschauer, Eltern und Trainer sehen Aufrufe und Ergebnisse in Echtzeit.' },
  { titel: 'Urkunden', text: 'Urkunden und Ergebnislisten aus den Platzierungen drucken.' },
  { titel: 'Abrechnung', text: 'Startgebühren je Verein, Zahlung vor Ort und Rechnungen.' },
];

export default function FunktionsBanner({ className = '' }) {
  return (
    <section className={`fb ${className}`.trim()} aria-labelledby="fb-titel">
      <div className="fb-innen">
        <div className="fb-marke">TDA Turniersoftware</div>
        <h2 id="fb-titel" className="fb-titel">Die komplette Turnierlösung</h2>
        <ul className="fb-liste">
          {FUNKTIONEN.map((f) => (
            <li key={f.titel} className="fb-punkt">
              <span className="fb-punkt-titel">{f.titel}</span>
              <span className="fb-punkt-text">{f.text}</span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
